import styled from 'styled-components';

export const Wrapper = styled.div`
    .ant-alert {
        width: 100%;
        border: none;
        border-bottom: 2px solid var(--colors-border-warning, #eb9d06);
        border-radius: 0;
    }
`;
